import { useState } from "react";
import { useNavigate } from "react-router-dom";
import InteractiveCarte from "../../pages/Carte/InteractiveCarte";
import WaterLifecycle from "./WaterLifecycle";
import WaterPrice from "./WaterPrice";
import WaterResult from "./WaterResult";

const WaterNavigationMenu = () => {
  const [activeSection, setActiveSection] = useState("carré-de-réunion");

  const navigate = useNavigate();
  const handleSectionChange = (section: any) => {
    setActiveSection(section);
    navigate(`/ouvrages-installations?${section}`);
  };

  return (
    <>
      <div className="flex flex-col items-center p-10 mt-5 md:p-0">
        <div className="flex justify-center space-x-4">
          <div
            className={`cursor-pointer  text-xs md:text-base ${
              activeSection === "carré-de-réunion"
                ? "text-black  text-xs font-bold md:text-base "
                : ""
            }`}
            onClick={() => handleSectionChange("carré-de-réunion")}
          >
            Carré de Réunion
            <hr
              className={
                activeSection === "carré-de-réunion"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>

          <div
            className={`cursor-pointer  text-xs md:text-base ${
              activeSection === "usine-Val-de-Gally"
                ? "text-black  text-xs font-bold md:text-base "
                : ""
            }`}
            onClick={() => handleSectionChange("usine-Val-de-Gally")}
          >
            Usine Val de Gally
            <hr
              className={
                activeSection === "usine-Val-de-Gally"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>

          <div
            className={`cursor-pointer text-xs md:text-base${
              activeSection === "réseau-de-Collecteurs"
                ? "text-black text-xs font-bold md:text-base "
                : ""
            }`}
            onClick={() => handleSectionChange("réseau-de-Collecteurs")}
          >
            Réseau de Collecteurs
            <hr
              className={
                activeSection === "réseau-de-Collecteurs"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer text-xs md:text-base${
              activeSection === "bassins-de-Stockage"
                ? "text-black font-bold text-xs  md:text-base"
                : ""
            }`}
            onClick={() => handleSectionChange("bassins-de-Stockage")}
          >
            Bassins de Stockage
            <hr
              className={
                activeSection === "bassins-de-Stockage"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
        </div>
        <div className="z-0 w-full max-w-2xl border-t border-gray-200 dark:border-gray-800" />
      </div>

      {activeSection === "carré-de-réunion" && <InteractiveCarte />}
      {activeSection === "usine-Val-de-Gally" && <WaterLifecycle />}

      {activeSection === "réseau-de-Collecteurs" && <WaterResult />}
      {activeSection === "bassins-de-Stockage" && <WaterPrice />}
    </>
  );
};

export default WaterNavigationMenu;
